import { DefaultOptionType } from "antd/es/select";
import { ZEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";

export const makeCurrencyOptions = (entities: ZEntity[], atrrCurr: ZUid) =>
  entities
    .map((e) => {
      const labelData = new Map(
        e.labelData?.labels.map((label) => [label.attrId, label]),
      );
      const attrLabelData = labelData.get(atrrCurr);
      if (!attrLabelData) return null;
      return {
        label: attrLabelData.labels?.[0],
        value: String(e.id),
      };
    })
    .filter((e) => !!e) as DefaultOptionType[];
